export const odluka_blag_likv = {
    templateId: 114,
    category: 4,
    templateTitle: 'Odluka o imenovanju likvidatora knjigovodstvenih isprava',
    templateDescription: `<p>Poduzetnik ili osoba koju poduzetnik odredi, odgovorna je za kontrolu vjerodostojnosti isprava koja se obavlja prije unosa podataka iz knjigovodstvene isprave u poslovne knjige na način da se ista potpiše ili odobri odnosno verificira (u slučaju elektroničkih isprava).</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Prije unosa podataka iz knjigovodstvene isprave u poslovne knjige poduzetnik ili osoba koju on odredi dužna je provjeriti vjerodostojnost knjigovodstvene isprave te istu potpisati ili odobriti na način iz kojeg se može jednoznačno utvrditi njezin identitet. </p>
    <p>U slučaju knjigovodstvenih isprava sastavljenih kao elektronički zapis poduzetnik ili osoba koju on odredi dužna je osigurati njihovu kontrolu i verifikaciju sukladno internim pravilima i procedurama.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o računovodstvu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o računovodstvu,',
            signature: 'Za Poreznog obveznika:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Porezni obvenznik),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O IMENOVANJU OSOBE KOJA ĆE OBAVLJATI VJERODOSTOJNOST KNJIGOVODSTVENE ISPRAVE - LIKVIDATOR',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovom Odlukom, sukladno Zakonu o računovodstvu, Porezni obveznik imenuje osobu koja će biti obvezna kontrolirati vjerodostojnost knjigovodstvenih isprava - likvidatora.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: 'text', content: 'Radnik' },
                    { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                    { type: "text", content: "," },
                    { type: 'text', content: 'iz' },
                    { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                    { type: 'text', content: ',' },
                    { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                    { type: 'text', content: 'OIB:' },
                    { type: "input",  required: true,},
                    { type: 'text', content: ', (u daljnjem tekstu: Radnik)'},
                    { type: 'text', content: ', imenuje se osobom koja će kod Poreznog obveznika kontrolirati vjerodostojnost knjigovodstvenih isprava - likvidator.' },
                ]
              }
            ]
          },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Likvidator ima sljedeće obveze:\r\n- provjeriti formalnu, materijalnu i računsku točnost knjigovodstvenih isprava kako bi se utvrdila njihova ispravnost i potpunost,\r\n- provjeriti ispravnost svih isprava koje su osnova za knjiženje poslovnih događaja (ulazne i izlazne isprave),\r\n- knjigovodstvene isprave koje nisu ispravne i potpune vratiti izdavatelju uz uputu o načinu ispravka pogreške, \r\n- odobriti knjigovodstvene isprave koje su ispravne i potpune.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Likvidator odobrava ispravne i potpune knjigovodstvene isprave pečatom na kojem se nalazi tiskanim slovima naziv LIKVIDIRANO ili vlastitim rukom stavlja oznaku LIKVIDIRANO, uz oznaku datuma te vlastitog imena i prezimena.',
                    value: '',
                },
            ],
            value: '',
        },   
      
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine, sve do opoziva iste."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Likvidatoru \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/114_odluka_blag_likv.ts